import {
  AuthenticationApi,
  DeviceTypesApi,
  Configuration,
  SuperGroupsApi,
  Middleware,
  FirmwaresApi,
  StbGroupsApi,
  UpgradeRulesApi,
  SystemHintsApi,
  UsersApi,
  ApiUsersApi,
  DevicesApi,
  GlobalSettingsApi,
  VersionApi,
  BatchMovesApi,
  ProvisioningDevicesApi,
  ActionHistoryApi,
  ReportsApi,
  JobsApi,
  RescueApi,
  DashboardApi,
  TagsApi,
} from '@openapi';
import { ApiError } from '@services/types';

// const baseUrl = process.env.API_URL || `http://localhost:8080/v2/api/ui`;
// const baseUrl = process.env.API_URL || `https://sota.sgsanapr.com/v2/api/ui`;
const baseUrl = process.env.API_URL || `/v2/api/ui`;

let configuration = new Configuration({ basePath: baseUrl });
let authApi = new AuthenticationApi(configuration);
let deviceTypesApi = new DeviceTypesApi(configuration);
let superGroupsApi = new SuperGroupsApi(configuration);
let firmwaresApi = new FirmwaresApi(configuration);
let stbGroupsApi = new StbGroupsApi(configuration);
let rulesApi = new UpgradeRulesApi(configuration);
let rescueApi = new RescueApi(configuration);
let systemHintsApi = new SystemHintsApi(configuration);
let usersApi = new UsersApi(configuration);
let apiUsersApi = new ApiUsersApi(configuration);
let devicesApi = new DevicesApi(configuration);
let globalSettingsApi = new GlobalSettingsApi(configuration);
let versionsApi = new VersionApi(configuration);
let batchMoveApi = new BatchMovesApi(configuration);
let provisionedDevicesApi = new ProvisioningDevicesApi(configuration);
let actionHistoryApi = new ActionHistoryApi(configuration);
let reportsApi = new ReportsApi(configuration);
let jobsApi = new JobsApi(configuration);
let dashboardApi = new DashboardApi(configuration);
let tagsApi = new TagsApi(configuration);

type SetAuthConfigurationArgs =
  | { token: null; handleTokenExpiration?: undefined }
  | { token: string; handleTokenExpiration: VoidFunction };

const errorMiddleware: Middleware = {
  post: async (context) => {
    if (context.response.status >= 200 && context.response.status < 300) {
      return context.response;
    }
    const error: ApiError['error'] = await context.response?.json();

    throw new ApiError(error, context.response.status);
  },
};

export const setAuthConfiguration = ({ token, handleTokenExpiration }: SetAuthConfigurationArgs) => {
  if (token) {
    const tokenMiddleware: Middleware = {
      post: async (context) => {
        if (context.response.status === 401) {
          handleTokenExpiration();
        }
        return context.response;
      },
    };
    configuration = new Configuration({
      basePath: baseUrl,
      accessToken: token,
      middleware: [tokenMiddleware, errorMiddleware],
    });
  } else {
    configuration = new Configuration({ basePath: baseUrl, middleware: [errorMiddleware] });
  }

  authApi = new AuthenticationApi(configuration);
  deviceTypesApi = new DeviceTypesApi(configuration);
  superGroupsApi = new SuperGroupsApi(configuration);
  firmwaresApi = new FirmwaresApi(configuration);
  stbGroupsApi = new StbGroupsApi(configuration);
  rulesApi = new UpgradeRulesApi(configuration);
  rescueApi = new RescueApi(configuration);
  systemHintsApi = new SystemHintsApi(configuration);
  usersApi = new UsersApi(configuration);
  apiUsersApi = new ApiUsersApi(configuration);
  devicesApi = new DevicesApi(configuration);
  globalSettingsApi = new GlobalSettingsApi(configuration);
  versionsApi = new VersionApi(configuration);
  batchMoveApi = new BatchMovesApi(configuration);
  provisionedDevicesApi = new ProvisioningDevicesApi(configuration);
  actionHistoryApi = new ActionHistoryApi(configuration);
  reportsApi = new ReportsApi(configuration);
  jobsApi = new JobsApi(configuration);
  dashboardApi = new DashboardApi(configuration);
  tagsApi = new TagsApi(configuration);
};

export const getAuthApi = () => authApi;
export const getDeviceTypesApi = () => deviceTypesApi;
export const getSuperGroupsApi = () => superGroupsApi;
export const getFirmwaresApi = () => firmwaresApi;
export const getStbGroupsApi = () => stbGroupsApi;
export const getRulesApi = () => rulesApi;
export const getRescueApi = () => rescueApi;
export const getSystemHintsApi = () => systemHintsApi;
export const getUsersApi = () => usersApi;
export const getApiUsersApi = () => apiUsersApi;
export const getDevicesApi = () => devicesApi;
export const getGlobalSettingsApi = () => globalSettingsApi;
export const getVersionsApi = () => versionsApi;
export const getBatchMoveApi = () => batchMoveApi;
export const getProvisionedDevicesApi = () => provisionedDevicesApi;
export const getActionHistoryApi = () => actionHistoryApi;
export const getReportsApi = () => reportsApi;
export const getJobsApi = () => jobsApi;
export const getTagsApi = () => tagsApi;
export const getDashboards = () => dashboardApi;
